// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../src/assets/images/canada.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Footer Styling */
.custom-footer {
  background: var(--clr-grey-3);
  padding: 2rem;
  text-align: center;
  color: var(--clr-white);
  font-family: var(--ff-primary);
  box-shadow: var(--light-shadow);
  position: relative;
  overflow: hidden;
}

:root[data-theme='dark'] .custom-footer {
  background: var(--clr-grey-5); 
}

.custom-footer-container {
  /* max-width: var(--max-width); */
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.custom-footer-logo {
  margin-bottom: 20px;
}

.custom-footer-logo-text {
  font-size: 2.2rem;
  font-weight: 700;
  color: var(--clr-primary-9);
  text-decoration: none;
  transition: color 0.3s ease, transform 0.3s ease;
}

.custom-footer-logo-text:hover {
  color: var(--clr-primary-6);
  transform: scale(1.05);
}

.custom-footer-logo-para {
  font-size: 1.1rem;
  font-weight: 400;
  color: var(--clr-primary-9);
  transition: color 0.3s ease, transform 0.3s ease;
}

.custom-footer-logo-para:hover {
  color: var(--clr-primary-6);
  transform: scale(1.05);
}

.custom-footer-sections {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}

.custom-footer-links,
.custom-footer-social,
.custom-footer-contact {
  flex: 1 1;
  margin: 10px;
  font-size: 1rem;
  font-weight: 500;
}

.custom-footer-links h4,
.custom-footer-social h4,
.custom-footer-contact h4 {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--clr-primary-10);
  transition: color 0.3s ease;
  margin-bottom: 10px;
  position: relative;
  padding-bottom: 4px;
}

.custom-footer-links h4::after,
.custom-footer-social h4::after,
.custom-footer-contact h4::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 40%; /* Adjust the width as needed */
  height: 2px;
  background-color: var(--clr-primary-6);
}


.custom-footer-links h4:hover,
.custom-footer-social h4:hover,
.custom-footer-contact h4:hover {
  color: var(--clr-primary-5);
}

/* .custom-footer-link-list {
  list-style: none;
  padding: 0;
  margin: 0;
} */
.custom-footer-link-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem; /* Adjusts spacing between links */
}

.custom-footer-link-list a {
  color: var(--clr-white);
  font-weight: 600;
  font-size: 1.2rem;
  text-decoration: none;
  transition: color 0.3s ease, transform 0.3s ease;
}

.custom-footer-link-list a:hover {
  color: var(--clr-primary-6);
  transform: translateX(3px);
}


.custom-footer-link-list li {
  margin-bottom: 8px;
}

.custom-footer-link-list li a {
  font-family: var(--ff-secondary);
  text-decoration: none;
  color: var(--clr-white);
  font-weight: 600;
  font-size: 1.1rem;
  transition: color 0.3s ease, transform 0.3s ease;
}

.custom-footer-link-list li a:hover {
  color: var(--clr-primary-6);
  transform: translateX(3px);
}

.custom-footer-social-links {
  display: flex;
  justify-content: center;
  animation: fadeIn 1.5s ease-in-out;
}

.custom-footer-contact p {
  margin: 0;
  margin-bottom: 8px;
  color: var(--clr-white);
  font-weight: 600;
  font-size: 1.2rem;
  font-family: var(--ff-secondary);
}

.custom-footer-contact p:hover {
  color: var(--clr-primary-7);
}
.custom-footer-professional-line {
  border-top: 1px solid var(--clr-primary-6);
  padding-top: 10px;
  margin-top: 20px;
  font-size: 1rem;
  color: var(--clr-grey-9);
  font-style: italic;
  animation: fadeInUp 1.5s ease-in-out;
}

.custom-footer-bottom {
  background-color: var(--clr-primary-6);
  padding: 10px 20px;
  color: var(--clr-white);
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
  margin-top: 20px;
  animation: slideInUp 1.5s ease-in-out;
}

.custom-footer-bottom p {
  margin: 0;
}



/* .social-overlay {
  width: 355px;
  height: 100px;
  margin-top: 1rem;
  background: url('../../images/ExhaleWelllness_Logomark_Inverse.svg') no-repeat center center;
  background-size: contain;
  opacity: 0.2;
} */

/* Responsive Adjustments */
@media (max-width: 768px) {
  .custom-footer {
    padding: 1rem;
  }

  .custom-footer-logo-text {
    font-size: 1.5rem;
  }

  .custom-footer-sections {
    flex-direction: column;
    align-items: center;
  }

  .custom-footer-links,
  .custom-footer-social,
  .custom-footer-contact {
    margin: 15px 0;
    text-align: center;
  }

  .custom-footer-link-list li {
    margin-bottom: 5px;
  }

  .custom-footer-social-links {
    flex-direction: column;
  }

  .custom-footer-contact p {
    font-size: 0.88rem;
  }

  .custom-footer-bottom {
    padding: 5px 0;
    font-size: 0.9rem;
  }
}

/* Scroll-to-top button styling */
.scroll-to-top {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  background-color: var(--clr-primary-6);
  color: var(--clr-logo-1);
  border: none;
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.scroll-to-top:hover {
  background-color: var(--clr-primary-4);
  transform: scale(1.1);
}

.custom-footer-logo {
  margin-bottom: 20px; 
}

.custom-footer-logo-text {
  font-size: 2rem; 
  font-weight: 700;
  color: var(--clr-primary-9);
  text-decoration: none;
  transition: color 0.3s ease, transform 0.3s ease;
}

.custom-footer-logo-text:hover {
  color: var(--clr-primary-6);
  transform: scale(1.05); 
}

.social-overlay {
  /* width: 380px; */
  height: 75px;
  margin-top: 2rem;
  /* margin-left: 3rem;  */
  background:   url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: contain;
  /* opacity: 0.7; */
}


@media (max-width: 768px) {
  .social-overlay {
    margin-left: 1.1rem; 
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/footer/Footer.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;;;EAGE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,UAAU,EAAE,+BAA+B;EAC3C,WAAW;EACX,sCAAsC;AACxC;;;AAGA;;;EAGE,2BAA2B;AAC7B;;AAEA;;;;GAIG;AACH;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAE,kCAAkC;AACjD;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,SAAS;AACX;;;;AAIA;;;;;;;GAOG;;AAEH,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;;;IAGE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;AACF;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,sCAAsC;EACtC,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,2DAA2D;EAC3D,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,6EAAkF;EAClF,wBAAwB;EACxB,kBAAkB;AACpB;;;AAGA;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Main Footer Styling */\n.custom-footer {\n  background: var(--clr-grey-3);\n  padding: 2rem;\n  text-align: center;\n  color: var(--clr-white);\n  font-family: var(--ff-primary);\n  box-shadow: var(--light-shadow);\n  position: relative;\n  overflow: hidden;\n}\n\n:root[data-theme='dark'] .custom-footer {\n  background: var(--clr-grey-5); \n}\n\n.custom-footer-container {\n  /* max-width: var(--max-width); */\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.custom-footer-logo {\n  margin-bottom: 20px;\n}\n\n.custom-footer-logo-text {\n  font-size: 2.2rem;\n  font-weight: 700;\n  color: var(--clr-primary-9);\n  text-decoration: none;\n  transition: color 0.3s ease, transform 0.3s ease;\n}\n\n.custom-footer-logo-text:hover {\n  color: var(--clr-primary-6);\n  transform: scale(1.05);\n}\n\n.custom-footer-logo-para {\n  font-size: 1.1rem;\n  font-weight: 400;\n  color: var(--clr-primary-9);\n  transition: color 0.3s ease, transform 0.3s ease;\n}\n\n.custom-footer-logo-para:hover {\n  color: var(--clr-primary-6);\n  transform: scale(1.05);\n}\n\n.custom-footer-sections {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.custom-footer-links,\n.custom-footer-social,\n.custom-footer-contact {\n  flex: 1;\n  margin: 10px;\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.custom-footer-links h4,\n.custom-footer-social h4,\n.custom-footer-contact h4 {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--clr-primary-10);\n  transition: color 0.3s ease;\n  margin-bottom: 10px;\n  position: relative;\n  padding-bottom: 4px;\n}\n\n.custom-footer-links h4::after,\n.custom-footer-social h4::after,\n.custom-footer-contact h4::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n  transform: translateX(-50%);\n  width: 40%; /* Adjust the width as needed */\n  height: 2px;\n  background-color: var(--clr-primary-6);\n}\n\n\n.custom-footer-links h4:hover,\n.custom-footer-social h4:hover,\n.custom-footer-contact h4:hover {\n  color: var(--clr-primary-5);\n}\n\n/* .custom-footer-link-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n} */\n.custom-footer-link-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem; /* Adjusts spacing between links */\n}\n\n.custom-footer-link-list a {\n  color: var(--clr-white);\n  font-weight: 600;\n  font-size: 1.2rem;\n  text-decoration: none;\n  transition: color 0.3s ease, transform 0.3s ease;\n}\n\n.custom-footer-link-list a:hover {\n  color: var(--clr-primary-6);\n  transform: translateX(3px);\n}\n\n\n.custom-footer-link-list li {\n  margin-bottom: 8px;\n}\n\n.custom-footer-link-list li a {\n  font-family: var(--ff-secondary);\n  text-decoration: none;\n  color: var(--clr-white);\n  font-weight: 600;\n  font-size: 1.1rem;\n  transition: color 0.3s ease, transform 0.3s ease;\n}\n\n.custom-footer-link-list li a:hover {\n  color: var(--clr-primary-6);\n  transform: translateX(3px);\n}\n\n.custom-footer-social-links {\n  display: flex;\n  justify-content: center;\n  animation: fadeIn 1.5s ease-in-out;\n}\n\n.custom-footer-contact p {\n  margin: 0;\n  margin-bottom: 8px;\n  color: var(--clr-white);\n  font-weight: 600;\n  font-size: 1.2rem;\n  font-family: var(--ff-secondary);\n}\n\n.custom-footer-contact p:hover {\n  color: var(--clr-primary-7);\n}\n.custom-footer-professional-line {\n  border-top: 1px solid var(--clr-primary-6);\n  padding-top: 10px;\n  margin-top: 20px;\n  font-size: 1rem;\n  color: var(--clr-grey-9);\n  font-style: italic;\n  animation: fadeInUp 1.5s ease-in-out;\n}\n\n.custom-footer-bottom {\n  background-color: var(--clr-primary-6);\n  padding: 10px 20px;\n  color: var(--clr-white);\n  text-align: center;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 8px;\n  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);\n  margin-top: 20px;\n  animation: slideInUp 1.5s ease-in-out;\n}\n\n.custom-footer-bottom p {\n  margin: 0;\n}\n\n\n\n/* .social-overlay {\n  width: 355px;\n  height: 100px;\n  margin-top: 1rem;\n  background: url('../../images/ExhaleWelllness_Logomark_Inverse.svg') no-repeat center center;\n  background-size: contain;\n  opacity: 0.2;\n} */\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .custom-footer {\n    padding: 1rem;\n  }\n\n  .custom-footer-logo-text {\n    font-size: 1.5rem;\n  }\n\n  .custom-footer-sections {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .custom-footer-links,\n  .custom-footer-social,\n  .custom-footer-contact {\n    margin: 15px 0;\n    text-align: center;\n  }\n\n  .custom-footer-link-list li {\n    margin-bottom: 5px;\n  }\n\n  .custom-footer-social-links {\n    flex-direction: column;\n  }\n\n  .custom-footer-contact p {\n    font-size: 0.88rem;\n  }\n\n  .custom-footer-bottom {\n    padding: 5px 0;\n    font-size: 0.9rem;\n  }\n}\n\n/* Scroll-to-top button styling */\n.scroll-to-top {\n  position: fixed;\n  bottom: 2rem;\n  right: 2rem;\n  background-color: var(--clr-primary-6);\n  color: var(--clr-logo-1);\n  border: none;\n  border-radius: 50%;\n  width: 2.5rem;\n  height: 2.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.2rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.3s ease;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  z-index: 1000;\n}\n\n.scroll-to-top:hover {\n  background-color: var(--clr-primary-4);\n  transform: scale(1.1);\n}\n\n.custom-footer-logo {\n  margin-bottom: 20px; \n}\n\n.custom-footer-logo-text {\n  font-size: 2rem; \n  font-weight: 700;\n  color: var(--clr-primary-9);\n  text-decoration: none;\n  transition: color 0.3s ease, transform 0.3s ease;\n}\n\n.custom-footer-logo-text:hover {\n  color: var(--clr-primary-6);\n  transform: scale(1.05); \n}\n\n.social-overlay {\n  /* width: 380px; */\n  height: 75px;\n  margin-top: 2rem;\n  /* margin-left: 3rem;  */\n  background:   url('../../../src/assets/images/canada.png') no-repeat center center;\n  background-size: contain;\n  /* opacity: 0.7; */\n}\n\n\n@media (max-width: 768px) {\n  .social-overlay {\n    margin-left: 1.1rem; \n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
